import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getPreviousRoundState = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/mine-game/get-unfinished-bet-state', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const getLiveStats = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/mine-game/live-stats', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const getBetHistory = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/mine-game/get-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const placeBet = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/mine-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const autoBet = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/mine-game/auto-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const openTile = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/mine-game/open-tile', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const cashOutBet = () => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/mine-game/cash-out-bet', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const getTopBets = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/mine-game/top-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}
